module.exports = __webpack_public_path__ + "static/media/dressRoom4.aa4666e0.png";